export default function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-white mb-4 animate-pulse">
          Thaye/Them Messaging
        </h1>
        <p className="text-xl text-white opacity-90">
          Something something clever pun outside HW
        </p>
      </div>
    </div>
  );
}